<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title>
        {{ $vuetify.lang.t('$vuetify.map.criticalPopup.retrainStates.title') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>{{ closeIcon }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <retrain-states ref="retrainStates" @state-changed="changeState" :is-state-empty="stateError"></retrain-states>
      </v-card-text>
      <v-card-actions class="px-5">
        <v-spacer></v-spacer>
        <v-btn text @click="sendRetrainState">{{ $vuetify.lang.t('$vuetify.map.criticalPopup.buttons.confirm') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RetrainStates from './retrainStates'
import { mdiClose } from '@mdi/js'

export default {
  name: 'retrainDialog',
  components: { RetrainStates },
  props: {
    dialog: Boolean
  },
  data: () => ({
    retrainState: null,
    stateError: false,
    closeIcon: mdiClose
  }),
  methods: {
    changeState (state) {
      this.retrainState = state

      if (this.stateError) {
        this.stateError = !this.stateError
      }
    },
    closeDialog () {
      this.$refs.retrainStates.resetForm()
      this.$emit('close-retrain-dialog')
    },
    sendRetrainState () {
      if (!this.retrainState) {
        this.stateError = true
      }

      if (!this.stateError) {
        this.closeDialog()
        this.$emit('retrain-state', this.retrainState)
      }
    }
  }
}
</script>

<style scoped>

</style>
